import { useState, useEffect, useRef } from 'react';

const BASE = process.env.REACT_APP_API_URL || 'https://web-production-120c.up.railway.app';

function adminApi(path, options = {}) {
  const TOKEN = localStorage.getItem('shaheen_admin_token') || '';
  return fetch(`${BASE}${path}`, {
    headers: { 'Content-Type': 'application/json', 'Authorization': TOKEN ? `Bearer ${TOKEN}` : '', ...options.headers },
    ...options,
  }).then(r => r.json());
}

const s = {
  page: { display: 'flex', height: '100%', overflow: 'hidden' },
  list: { width: 300, borderRight: '0.5px solid var(--border)', display: 'flex', flexDirection: 'column', flexShrink: 0 },
  listHeader: { padding: '14px 16px', borderBottom: '0.5px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  listTitle: { fontSize: 13, fontWeight: 500, color: 'var(--text)' },
  alertBadge: { fontSize: 10, background: 'var(--red-bg)', color: 'var(--red)', border: '0.5px solid var(--red)', padding: '2px 7px', borderRadius: 8 },
  listScroll: { flex: 1, overflowY: 'auto' },
  convRow: { padding: '12px 16px', borderBottom: '0.5px solid var(--border)', cursor: 'pointer', transition: 'background 0.1s' },
  convRowActive: { background: 'var(--raised)' },
  convTop: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 4 },
  convName: { fontSize: 13, fontWeight: 500, color: 'var(--text)' },
  convTime: { fontSize: 10, color: 'var(--text3)' },
  convMsg: { fontSize: 12, color: 'var(--text2)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 220 },
  unreadDot: { width: 7, height: 7, borderRadius: '50%', background: 'var(--gold)', flexShrink: 0 },
  tier: { fontSize: 9, padding: '1px 5px', borderRadius: 5, letterSpacing: '0.06em' },
  main: { flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' },
  chatHeader: { padding: '14px 20px', borderBottom: '0.5px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: 'var(--surface)', flexShrink: 0 },
  chatName: { fontSize: 14, fontWeight: 500, color: 'var(--gold)' },
  chatSub: { fontSize: 11, color: 'var(--text3)', marginTop: 1 },
  messages: { flex: 1, overflowY: 'auto', padding: '16px 20px', display: 'flex', flexDirection: 'column', gap: 12 },
  msgRow: { display: 'flex', gap: 8, maxWidth: '80%' },
  msgUser: { alignSelf: 'flex-end', flexDirection: 'row-reverse' },
  avatar: { width: 28, height: 28, borderRadius: '50%', background: 'var(--raised)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 500, color: 'var(--gold)', flexShrink: 0 },
  bubble: { background: 'var(--surface)', border: '0.5px solid var(--border)', borderRadius: 10, padding: '9px 13px', fontSize: 13, color: 'var(--text2)', lineHeight: 1.6 },
  bubbleUser: { background: 'var(--raised)', borderColor: 'var(--border2)', color: 'var(--text)' },
  bubbleAdvisor: { background: '#0a1a0a', borderColor: 'var(--green)', color: '#90c090' },
  msgTime: { fontSize: 10, color: 'var(--text3)', marginTop: 3 },
  replyArea: { padding: '12px 20px', borderTop: '0.5px solid var(--border)', background: 'var(--surface)', flexShrink: 0 },
  replyLabel: { fontSize: 10, color: 'var(--text3)', letterSpacing: '0.06em', marginBottom: 6 },
  replyRow: { display: 'flex', gap: 8 },
  replyInput: { flex: 1, background: 'var(--raised)', border: '0.5px solid var(--border)', borderRadius: 8, padding: '9px 14px', fontSize: 13, color: 'var(--text)', outline: 'none', fontFamily: 'inherit', resize: 'none', minHeight: 60 },
  replyBtn: { background: 'var(--gold)', color: 'var(--bg)', border: 'none', borderRadius: 8, padding: '0 16px', fontSize: 12, fontWeight: 500, cursor: 'pointer', flexShrink: 0 },
  empty: { flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text3)', fontSize: 13 },
  alertBanner: { margin: '0 20px 12px', background: 'var(--red-bg)', border: '0.5px solid var(--red)', borderRadius: 8, padding: '10px 14px' },
  alertText: { fontSize: 12, color: 'var(--red)', fontWeight: 500 },
  alertSub: { fontSize: 11, color: 'var(--red)', opacity: 0.7, marginTop: 2 },
  ackBtn: { fontSize: 11, background: 'none', border: '0.5px solid var(--red)', color: 'var(--red)', borderRadius: 5, padding: '3px 8px', cursor: 'pointer', marginTop: 6 },
};

const tierColors = {
  black: { background: 'var(--gold-dim)', color: 'var(--gold)' },
  elite: { background: '#101a18', color: '#608070' },
  core:  { background: '#181810', color: '#807050' },
};

function fmt(ts) {
  if (!ts) return '';
  try {
    const d = new Date(ts);
    const now = new Date();
    const diff = (now - d) / 1000;
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
  } catch { return ''; }
}

function initials(name) {
  return (name || '').split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();
}

export default function Inbox() {
  const [inbox, setInbox] = useState([]);
  const [alerts, setAlerts] = useState([]);
  const [selected, setSelected] = useState(null);
  const [messages, setMessages] = useState([]);
  const [reply, setReply] = useState('');
  const [sending, setSending] = useState(false);
  const bottomRef = useRef(null);

  const loadInbox = async () => {
    try {
      const d = await adminApi('/admin/inbox');
      setInbox(d.inbox || []);
    } catch {}
  };

  const loadAlerts = async () => {
    try {
      const d = await adminApi('/admin/escalations');
      setAlerts(d.alerts || []);
    } catch {}
  };

  const loadConversation = async (clientId) => {
    try {
      const d = await adminApi(`/admin/inbox/${clientId}`);
      setMessages(d.messages || []);
    } catch {}
  };

  useEffect(() => {
    loadInbox();
    loadAlerts();
    const id = setInterval(() => { loadInbox(); loadAlerts(); }, 15000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    if (selected) {
      loadConversation(selected.client_id);
      const id = setInterval(() => loadConversation(selected.client_id), 8000);
      return () => clearInterval(id);
    }
  }, [selected]);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const handleReply = async () => {
    if (!reply.trim() || !selected || sending) return;
    setSending(true);
    try {
      await adminApi(`/admin/inbox/${selected.client_id}/reply`, {
        method: 'POST',
        body: JSON.stringify({ message: reply.trim() }),
      });
      setReply('');
      await loadConversation(selected.client_id);
    } catch {}
    setSending(false);
  };

  const ackAlert = async (alertId) => {
    try {
      await adminApi(`/admin/escalations/${alertId}/acknowledge`, { method: 'POST' });
      setAlerts(a => a.filter(x => x.alert_id !== alertId));
    } catch {}
  };

  return (
    <div style={s.page}>
      <div style={s.list}>
        <div style={s.listHeader}>
          <span style={s.listTitle}>Conversations ({inbox.length})</span>
          {alerts.length > 0 && <span style={s.alertBadge}>{alerts.length} alert{alerts.length > 1 ? 's' : ''}</span>}
        </div>
        <div style={s.listScroll}>
          {inbox.length === 0 && <div style={{ padding: 20, fontSize: 12, color: 'var(--text3)' }}>No conversations yet</div>}
          {inbox.map(c => (
            <div key={c.client_id}
              style={{ ...s.convRow, ...(selected?.client_id === c.client_id ? s.convRowActive : {}) }}
              onClick={() => setSelected(c)}
              onMouseEnter={e => e.currentTarget.style.background = 'var(--raised)'}
              onMouseLeave={e => e.currentTarget.style.background = selected?.client_id === c.client_id ? 'var(--raised)' : ''}
            >
              <div style={s.convTop}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <span style={s.convName}>{c.client_name}</span>
                  <span style={{ ...s.tier, ...tierColors[c.client_tier] || tierColors.core }}>{(c.client_tier || 'core').toUpperCase()}</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  {c.unread_user_messages > 0 && <div style={s.unreadDot} />}
                  <span style={s.convTime}>{fmt(c.last_timestamp)}</span>
                </div>
              </div>
              <div style={s.convMsg}>
                {c.last_message_role === 'user' ? c.client_name.split(' ')[0] : 'Shaheen'}: {c.last_message}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div style={s.main}>
        {!selected ? (
          <div style={s.empty}>Select a conversation to view</div>
        ) : (
          <>
            <div style={s.chatHeader}>
              <div>
                <div style={s.chatName}>{selected.client_name}</div>
                <div style={s.chatSub}>{selected.client_id} — {(selected.client_tier || 'core').toUpperCase()}</div>
              </div>
            </div>

            {alerts.filter(a => a.client_id === selected.client_id).map(alert => (
              <div key={alert.alert_id} style={s.alertBanner}>
                <div style={s.alertText}>{alert.severity} — {alert.summary}</div>
                <div style={s.alertSub}>{fmt(alert.created_at)}</div>
                <button style={s.ackBtn} onClick={() => ackAlert(alert.alert_id)}>Acknowledge</button>
              </div>
            ))}

            <div style={s.messages}>
              {messages.map((m, i) => {
                const isUser = m.role === 'user';
                const isAdvisor = m.content?.startsWith('[Advisor]');
                return (
                  <div key={i} style={{ ...s.msgRow, ...(isUser ? s.msgUser : {}) }}>
                    <div style={s.avatar}>{isUser ? initials(selected.client_name) : 'S'}</div>
                    <div>
                      <div style={{ ...s.bubble, ...(isUser ? s.bubbleUser : {}), ...(isAdvisor ? s.bubbleAdvisor : {}) }}>
                        {(m.content || '').split('\n').map((line, j) => (
                          <span key={j}>{line}{j < (m.content || '').split('\n').length - 1 && <br />}</span>
                        ))}
                      </div>
                      <div style={{ ...s.msgTime, ...(isUser ? { textAlign: 'right' } : {}) }}>
                        {isAdvisor ? 'You (Advisor) · ' : ''}{fmt(m.timestamp)}
                      </div>
                    </div>
                  </div>
                );
              })}
              <div ref={bottomRef} />
            </div>

            <div style={s.replyArea}>
              <div style={s.replyLabel}>REPLY AS ADVISOR — client will see this as a Shaheen response</div>
              <div style={s.replyRow}>
                <textarea
                  style={s.replyInput}
                  value={reply}
                  onChange={e => setReply(e.target.value)}
                  placeholder="Type your response..."
                  onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleReply(); } }}
                />
                <button style={s.replyBtn} onClick={handleReply} disabled={sending}>
                  {sending ? '...' : 'Send'}
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
